<template>
  <div class="page-404-container">
    <fifty-fifty :schema="schema"></fifty-fifty>
  </div>
</template>

<script>
import FiftyFifty from '@/scripts/components/sections/FiftyFifty.vue'

export default {
  name: 'Page404',
  components: { FiftyFifty },
  props: {
    schema: Object
  }
}
</script>

<style scoped lang="scss">
  .page-404-container {
    max-width: 1440px;
    margin: auto;
    /deep/ .sw__image {
      @include mobile-only {
        height: auto;
      }
    }
  }

  /deep/ .ff__preheader {
    margin-bottom: 32px;
    @include mobile-only {
      margin-bottom: 24px;
    }
  }

  /deep/ .ff__header {
    margin-bottom: 24px;
  }

  /deep/ .sw .ff__image--mobile {
    height: 376px;
    width: 375px;
    max-width: 375px;
    margin: 0px auto;
  }
  /deep/ .sw__main {
    width: 100vw;
  }
  /deep/ .ff__body,
  /deep/ .ff__body p {
    line-height: 1.375rem;
    margin-bottom: 16px;
  }
  /deep/ .ff__header {
    @include tablet-up {
      height: 126px;
      width: 320px;
      color: $color-black;
      font-family: $font-family-primary;
      font-size: 32px;
      letter-spacing: 0;
      line-height: 42px;
    }
  }
  /deep/ .ff__image--desktop {
    max-width: 720px;
  }
  /deep/ .sw .ff__image--mobile {
    width: 100vw;
    max-width: 100vw;
  }

  /deep/ .ff__main-wrap {
    max-width: 320px;
    @include mobile-only {
      max-width: 300px;
      margin-left: auto;
      margin-right: auto;
    }
    @include desktop-up {
      margin-left: 152px;
    }
  }

  /deep/ .sw {
    max-width: 100%;
    padding: 40px 0;
    @include mobile-tablet {
      padding: 0;
    }

    &__main-image-content-container {
      @include tablet-up {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

</style>
